import { api } from '@services/apiInterceptor'

import type { ApiRequestWithBodyAndResponseTypeProps, ApiRequestWithBodyProps, ApiRequestWithQueryParamsProps } from './types'

export const apiRequestWithBody = async ({ url, method, body, headers, params }: ApiRequestWithBodyProps) => {
  try {
    const response = await api({
      url,
      method,
      data: body,
      params: params,
      headers: {
        ...(body ? { 'Content-Type': 'application/json' } : {}),
        ...headers
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const apiRequestWithBodyAndResponseType = async ({ url, method, body, headers, params, responseType }: ApiRequestWithBodyAndResponseTypeProps) => {
  try {
    const response = await api({
      url,
      method,
      data: body,
      params: params,
      responseType,
      headers: {
        ...(body ? { 'Content-Type': 'application/json' } : {}),
        ...headers
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const apiRequestWithQueryParams = async ({ url, method, params, headers }: ApiRequestWithQueryParamsProps) => {
  try {
    const response = await api(url, {
      method,
      params,
      headers
    })
    return response.data
  } catch (error) {
    throw error
  }
}
